import { CHAPTERS, type Section } from "./data"
import { QUESTIONS } from "./questions"
import { startQuiz } from "./quizState"
import { sectionCoverage, sectionStatus } from "./studySignals"

const SECTIONS: Section[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export function SectionPicker() {
  const coverage = new Map(sectionCoverage().map((c) => [c.section, c]))

  return (
    <div class="section-picker">
      {SECTIONS.map((s) => {
        const count = QUESTIONS.filter((q) => q.status === "verified" && q.answer.section === s).length
        const cov = coverage.get(s)
        const status = cov ? sectionStatus(cov) : "not-started"
        const seen = cov?.seen ?? 0
        const accuracyPct = cov && cov.attempts > 0 ? Math.round((cov.correct / cov.attempts) * 100) : null
        return (
          <button
            key={s}
            type="button"
            class={`section-chip section-chip-${status}`}
            onClick={() => startQuiz("section", s)}
          >
            <span class="section-chip-num">Section {String(s).padStart(2, "0")}</span>
            <span class="section-chip-name">{CHAPTERS[s].title}</span>
            <span class="section-chip-status">
              {seen} / {count} seen
              {accuracyPct !== null && <span class="section-chip-accuracy"> · {accuracyPct}% correct</span>}
            </span>
          </button>
        )
      })}
    </div>
  )
}
